// Filename: collections/activitys
define('collections/calendar/days',[
    'underscore',
    'backbone',
    'mustache',
    'moment',

    'utils',
    'services/api',
    // Pull in the Model module from above
    'models/calendar/day'
], function(
    // libs
    _, Backbone, Mustache, moment, U,
    // src
    API,
    // model
    MCalendarDay
) {

    var CCalendarDays = Backbone.Collection.extend({
        model: MCalendarDay,
        url: function() {
            var userUrl = Mustache.render("users/{{id}}/", { id: this.user }),
                url = Mustache.render("{{{base}}}calendar/days/{{{date}}}/?numDays={{{count}}}", {
                    base: this.user ? userUrl : '',
                    date: this.date.format('YYYY/MM/DD'),
                    count: this.count
                });

            if (this.type) {
                url = Mustache.render(url + "&type={{type}}", {
                    type: this.type
                });
            }

            if (this.customDataId) {
                url = Mustache.render(url + "&customDataId={{customDataId}}", {
                    customDataId: this.customDataId
                });
            }
            return API.url(url);
        },
        initialize: function(models, opt) {
            if (opt) {
                this.date = opt.date ? opt.date : moment();
                this.count = opt.count ? opt.count : 1;
                this.user = opt.user;
                this.type = opt.type;
                this.customDataId = opt.customDataId;
            }

        },

        setDateRange: function(date, count) {
            this.date = date;
            this.count = count;
            return this;
        },

        fetch: function(opt) {
            opt = opt || {};
            if (opt.date) this.date = opt.date;
            if (opt.count) this.count = opt.count;
            if (opt.user) this.user = opt.user;

            return CCalendarDays.__super__.fetch.call(this, opt);
        },

        getByDate: function(date) {
            return this.get(API.formatDate(moment(date)));
        },

        updateItem: function(activity, options) {
            var day = this.getByDate(activity.get('date'));
            if (day) {
                day.updateItem(activity, options);
            }
            return this;
        },

        /**
         * Updates all the days items that are related to the updated session.
         * @param  {MSession} session - backbone model of the session.
         * @return {CCalendarDays}   this - to enable chaining.
         */
        updateSession: function(session, options) {
            this.each(function(day) {
                day.updateSession(session, options);
            });

            // adds the new items
            if (session.hasReceivedChanges()) {
                var added = session.getReceivedChanges().added;
                _.each(added, function(item) {
                    var day = this.getByDate(item.date);
                    if (day) {
                        day.getItems().add(item, options);
                    }
                }, this);
            }

            return this;
        },

        updateDate: function(activity, options) {
            var day = this.getByDate(activity.get('date'));
            if (day) {
                day.getItems().add(activity, options);
            }

            return this;
        },

        getAllItems: function(type) {
            return this.chain().map(function(day) {
                if (type) {
                    return _.filter(day.getItems().models, function(model) {
                        return model.attributes.type === type;
                    });
                }
                return day.getItems().models;
            }).flatten().value();
        },

    });

    // You don't usually return a collection instantiated
    return CCalendarDays;
});

